import { isNumber } from "@bonusmap/shared_ui/library";
import { CollectorExtensionBase } from "./collector-extension-base.js"

export class usersCollectorExtension extends CollectorExtensionBase {
    static webComponentName: string = "users-collector-extension";
    constructor() {
        super();
    }
    
    
    onCollectorReady(): void {
        // Posso aggiungere logica specifica per l'utente qui
        this.documentBodyDelegate.on('input', 'input[name="password_hash"]', (event: Event) => {
            console.log(`Input cambiato per user ${(event.target as HTMLInputElement).value as string}`);
        });
    }

    onDataCollect(data: Record<string, any>): Record<string, any> {
        // Aggiungo la logica per hash della password
        const defaultPermissionId = data['default_permission_id'];
        if(isNumber(defaultPermissionId) ) {
            data['default_permission_id'] = Number(defaultPermissionId);
        }
        
        const organizationId = data['organization_id'];
        if(!isNumber(organizationId) ) {
           
            data['organization_id'] = this.loggedOrganizationId || 0;
        }
        return data;
    }
} 